// chartDarkBase.js
const chartDarkBase = {
	backgroundColor: "transparent",

	textStyle: {
		color: "#E5E7EB",
	},

	title: {
		textStyle: { color: "#F9FAFB" },
		subtextStyle: { color: "#9CA3AF" },
	},

	tooltip: {
		backgroundColor: "#1F2937",
		borderColor: "#374151",
		textStyle: { color: "#F3F4F6" },
	},

	xAxis: {
		axisLine: { lineStyle: { color: "#4B5563" } },
		axisLabel: { color: "#D1D5DB" },
		splitLine: { lineStyle: { color: "#374151" } },
	},

	yAxis: {
		axisLine: { lineStyle: { color: "#4B5563" } },
		axisLabel: { color: "#D1D5DB" },
		splitLine: { lineStyle: { color: "#374151" } },
	},
};

// 產品購買分析
const orderStatusMap = {
	ordered: {
		label: "已訂購",
		color: "#5B0F74",
	},
	notOrdered: {
		label: "未訂購",
		color: "#E5EAF1",
	},
};

// 年度平均客單價
const spendLevelMap = {
	A: {
		label: "A (5K~8K)",
		color: "#7E2E9C",
	},
	B: {
		label: "B (3K~5K)",
		color: "#94A3B8",
	},
	C: {
		label: "C (1K~3K)",
		color: "#CBD5E1",
	},
	D: {
		label: "D (<1K)",
		color: "#E2E8F0",
	},
	S: {
		label: "S (8K+)",
		color: "#4C0073",
	},
};

// 年度平均客單價
const purchaseLevelMap = {
	A: {
		label: "A (8~11)",
		color: "#7E2E9C",
	},
	B: {
		label: "B (5~7)",
		color: "#94A3B8",
	},
	C: {
		label: "C (2~4)",
		color: "#CBD5E1",
	},
	D: {
		label: "D (<2)",
		color: "#E2E8F0",
	},
	S: {
		label: "S (12K+)",
		color: "#4C0073",
	},
};

// 年度消費金額
const totalSpendLevelMap = {
	A: {
		label: "A (20K~30K)",
		color: "#7E2E9C",
	},
	B: {
		label: "B (10K~20K)",
		color: "#94A3B8",
	},
	C: {
		label: "C (5K~10K)",
		color: "#CBD5E1",
	},
	D: {
		label: "D (<5K)",
		color: "#E2E8F0",
	},
	S: {
		label: "S (30K+)",
		color: "#4C0073",
	},
};

const PIE_PALETTE = ["#5B0F74", "#E5EAF1", "#F59E0B", "#10B981"];

export { orderStatusMap, spendLevelMap, purchaseLevelMap, totalSpendLevelMap, chartDarkBase, PIE_PALETTE };
